import React from 'react'

import { Instrument, ObjectHash } from '../../../types/shared'
import { IChartThemeColors } from '../../models/constants'
import fetchApi from '../../utils/fetch_api'

type SettingsReqData = Partial<{
  colors: { light: Partial<IChartThemeColors>; dark: Partial<IChartThemeColors> }
  settings: ObjectHash
  instrument: Instrument
}>

async function saveSettingsApiRequest({ colors, settings, instrument }: SettingsReqData) {
  try {
    await fetchApi({
      location: '/api/settings_submit.ashx',
      method: 'POST',
      throwOnStatusCodes: [404],
      body: new URLSearchParams(
        colors
          ? { colors: JSON.stringify(colors) }
          : { settings: JSON.stringify(settings), instrument: instrument ?? '' }
      ),
      contentType: 'application/x-www-form-urlencoded',
    })
    window.gtag?.('event', 'save', { event_category: 'settings', event_label: colors ? 'colors' : 'studies' })
  } catch {
    // ignore error
  }
}

export function useSaveSettings() {
  const [isSaving, setIsSaving] = React.useState(false)

  const saveSettings = React.useCallback(async (settings: SettingsReqData) => {
    setIsSaving(true)
    await saveSettingsApiRequest(settings)
    setIsSaving(false)
  }, [])

  return React.useMemo(() => ({ isSaving, saveSettings }), [isSaving, saveSettings])
}
